<form [formGroup]="recoverPasswordForm" (ngSubmit)="onRecoverPassword()" novalidate>
  <div class="form-group">
    <label for="email">Enter your account email</label>
    <input
      id="email"
      formControlName="email"
      type="email"
      class="form-control"
      placeholder="Email address"
      required
    />
  </div>
  <button type="submit" class="btn btn-primary">Reset Password</button>
</form>

<p class="text-success" *ngIf="successMessage">{{ successMessage }}</p>
<p class="text-danger" *ngIf="errorMessage">{{ errorMessage }}</p>
